export default "__VITE_ASSET__3ae98b87__"